import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, RevealOnView } from '@/components/ui';
import { CONTENT_SLIDE } from '@/utils/animation';

const CARD_KEYS = [
  { key: 'visit', to: '/contact#contact-asia-heading' },
  { key: 'contact', to: '/contact' },
] as const;

export function GetInTouchSection() {
  const { t } = useTranslation();
  return (
    <section
      aria-labelledby="get-in-touch-heading"
      className="bg-clearlab-oat px-6 pb-30 md:px-20 md:pb-50"
    >
      <RevealOnView
        {...CONTENT_SLIDE}
        className="mx-auto flex w-full max-w-content-865 flex-col gap-20 md:gap-30"
      >
        <hr className="w-full border-0 border-t border-clearlab-divider-darker/60" />

        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:gap-10">
          <h2
            id="get-in-touch-heading"
            className="shrink-0 text-label-16 font-bold tracking-tight text-clearlab-midnight lg:w-60"
          >
            {t('home.getInTouch.heading')}
          </h2>

          <div className="flex flex-1 flex-col gap-10 md:flex-row md:items-stretch md:justify-between md:gap-10">
            {CARD_KEYS.map(({ key, to }, idx) => (
              <Fragment key={key}>
                <div className="flex flex-col gap-10 md:w-60 md:flex-none">
                  <div className="flex flex-col gap-2">
                    <p className="text-label-12 font-semibold tracking-tight text-clearlab-steel">
                      {t(`home.getInTouch.${key}.eyebrow`)}
                    </p>
                    <p className="text-label-16 leading-6 tracking-tight text-black">
                      {t(`home.getInTouch.${key}.description`)}
                    </p>
                  </div>
                  <hr className="hidden w-6 border-0 border-t border-clearlab-divider-darker/60 md:mt-auto md:block" />
                  <Button to={to} variant="transparent" size="small" tone="blue" iconRight>
                    {t(`home.getInTouch.${key}.cta`)}
                  </Button>
                </div>
                {idx < CARD_KEYS.length - 1 && (
                  <hr className="w-6 border-0 border-t border-clearlab-divider-darker/60 md:hidden" />
                )}
              </Fragment>
            ))}
          </div>
        </div>
      </RevealOnView>
    </section>
  );
}
